import React from 'react';
import {LazyImage} from "../../../Components";
import {detectEnglishLang} from "../../../Services";

function TriadBigRightSec({item,right,right_bottom,right_top,LinkDispatcher}){



    return(
        <div className="block-container">
            {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
            {right.image ? <div className={`block-pool ${item.has_shadow?"shadow-sec":""}`}
                                 style={{order: 1}}>
                <div className="block-item-vertical">
                    <div className="wrapper"
                         onClick={() => LinkDispatcher(right_top.link_to, right_top)}>
                        <img className="max-height" src={right_top.image} alt=""/>
                        <span className="block-title">{right_top.title}</span>
                    </div>
                    <div className="wrapper"
                         onClick={() => LinkDispatcher(right_bottom.link_to, right_bottom)}>
                        <img className="max-height" src={right_bottom.image} alt=""/>
                        <span className="block-title">{right_bottom.title}</span>
                    </div>
                </div>
                <div className="block-item-vertical">
                    <div className="wrapper"
                         onClick={() => LinkDispatcher(right.link_to, right)}>
                        <img src={right.image} alt=""/>
                        <span className="block-title">{right.title}</span>
                    </div>
                </div>
            </div> : null}
        </div>
            )
}

export default TriadBigRightSec
